import { Button, EButtonColorVariant, EHeadingStyleVariant, Heading } from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

export const IssuuReport = () => {
  const intl = useIntl();
  const title = intl.formatMessage({
    defaultMessage: 'Generations in the Wild 2024',
    id: '5w6VoQ',
  });
  return (
    <div className="text-white bg-primary-800">
      <div className="flex flex-col items-center section-spacing md:gap-6 gap-4">
        <div className="mx-auto mb-8 text-center max-w-[900px]">
          <Heading variant={EHeadingStyleVariant.H1} className="mb-4 text-[#A2AA3D]">
            {title}
          </Heading>
          <Heading variant={EHeadingStyleVariant.H5}>
            <FormattedMessage
              defaultMessage="A research report exploring the motivations and benefits that road trips and time spent outdoors brings four generations of American families."
              id="zAtjMk"
            />
          </Heading>
        </div>

        {/* embed code from ISSUU dashboard */}
        <div
          style={{
            position: 'relative',
            paddingTop: 'calc(60% + 50px)',
            height: 0,
            width: '100%',
          }}>
          <iframe
            allow="clipboard-write"
            sandbox="allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox allow-forms"
            allowFullScreen={true}
            style={{
              position: 'absolute',
              border: 'none',
              width: '100%',
              height: '100%',
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
            }}
            src="https://e.issuu.com/embed.html?d=outdoorsy-gitw-report-2024&pageLayout=singlePage&u=outdoorsy-rv"
            title={title}
          />
        </div>

        <Button
          href="https://www.outdoorsy.com/pdf/Outdoorsy-GITW-Report-2024.pdf"
          variant={EButtonColorVariant.Tertiary}
          className="mt-6 text-white !bg-[#A2AA3D] !border-[#A2AA3D]"
          label={intl.formatMessage({ defaultMessage: 'Download report', id: 'KEfeC0' })}
          target="_blank"
        />
      </div>
    </div>
  );
};
